import React from 'react';
import { Popover, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { getTerme } from '../common/glossaire';

// Affiche une icône d'aide (?) qui révèle la définition d'un terme métier
// au survol (Tooltip court) ou au clic (Popover long).
//
// Usage simple — tooltip court :
//   <TermHelp term="primeNette" />
//
// Variante avec libellé inline :
//   <span>Prime nette <TermHelp term="primeNette" /></span>
//
// Variante popover (clic, plus détaillé) :
//   <TermHelp term="commission" mode="popover" />
//
const TermHelp = ({ term, mode = 'tooltip', size = 13, color = '#1A2B5F', style = {} }) => {
    const def = getTerme(term);
    if (!def) return null;

    const icon = (
        <QuestionCircleOutlined
            style={{ color, fontSize: size, marginLeft: 4, cursor: 'help', verticalAlign: 'middle', ...style }}
            aria-label={`Aide : ${def.label}`}
        />
    );

    if (mode === 'popover') {
        return (
            <Popover
                title={<strong>{def.label}</strong>}
                content={
                    <div style={{ maxWidth: 320 }}>
                        <p style={{ marginBottom: 8 }}>{def.short}</p>
                        {def.long && <p style={{ marginBottom: 0, color: '#595959', fontSize: 13 }}>{def.long}</p>}
                    </div>
                }
                trigger={['click', 'hover']}
            >
                {icon}
            </Popover>
        );
    }

    return (
        <Tooltip
            title={
                <div>
                    <strong>{def.label}</strong>
                    <div style={{ fontSize: 12, marginTop: 2 }}>{def.short}</div>
                </div>
            }
        >
            {icon}
        </Tooltip>
    );
};

export default TermHelp;
